import React from "react";
import "./Categories.scss";
const Categories = () => {
  return <div>Categories</div>;
};

export default Categories;
